module.exports = __webpack_public_path__ + "img/ic-my-profile-hospital.f05cc70e.png";